import validator from 'validator'
import _ from 'lodash'
import { isValidPhoneNumber } from 'react-phone-number-input/max'
import {transliterate as tr} from 'transliteration'

// assets
import Strings from '../assets/strings.json'

export default (val, valSettings, settings) => {
  let msg = false
  val = val ? val.toString() : ''
  
  _.each(valSettings, (setting, rule) => {
    switch (rule){
      case 'required':
        msg = validator.isEmpty(val) ? Strings[document.body.dataset.lang].required : false
        break
      case 'equal': 
        msg = val !== setting ? Strings[document.body.dataset.lang].mustMatch : false
        break
      case 'integer':
        msg = !validator.isInt(val) ? Strings[document.body.dataset.lang].int : false
        break
      case 'min':
        msg = validator.isInt(val, {lt: parseInt(setting)}) ? Strings[document.body.dataset.lang].min : false
        break
      case 'max':
        msg = validator.isInt(val, {gt: parseInt(setting)}) ? Strings[document.body.dataset.lang].max : false
        break
      case 'minStr':
        msg = val.length < setting ? Strings[document.body.dataset.lang].minStr + ' ' + setting : false
        break
      case 'maxStr':
        msg = val.length > setting ? Strings[document.body.dataset.lang].minStr + ' ' + setting : false
        break
      case 'number':
        msg = !/^\d+$/.test(val) ? Strings[document.body.dataset.lang].number : false
        break
      case 'list':
        const dep = settings.departments.filter(d => tr(d.municipalities).split(',').includes(tr(val)))
        msg = settings.list.filter(l => tr(l) === tr(val)).length === 0 ? Strings[document.body.dataset.lang].notValidMun : (dep.length === 0 ? Strings[document.body.dataset.lang].noFireDep : (dep[0].check ? false : Strings[document.body.dataset.lang].contactOther.replace('@1', dep[0].name).replace('@2', dep[0].phone).replace(new RegExp('@3', 'g'), dep[0].email)))
        break
      case 'phone':
        msg = val && isValidPhoneNumber(val) ? false : Strings[document.body.dataset.lang].invalidPhone 
        break
      case 'email':
        msg = !validator.isEmail(val) ? Strings[document.body.dataset.lang].invalidEmail : false
        break
      default:
        msg = false
        break
    }

    if (msg){
      return false
    }
  })
  
  return msg
}